import React from 'react';
import BaseApp from '../../base-react/components/AppMain';
import { publicRoutes } from '../routes';
export const App = () => {
    return React.createElement(BaseApp, { routes: publicRoutes });
};
